import ym from 'react-yandex-metrika';

import { YmParams } from 'shared/typings';

import { getYmParams } from './getYmParams';

const debugMode = import.meta.env.VITE_ANALYTICS_DEBUG_MODE === 'true';

export const sendYmEvent = (eventName: string, eventOptions: Partial<YmParams>) => {
	const eventParams = { ...getYmParams(), ...eventOptions };

	if (debugMode) {
		console.log(eventName, eventParams);
	} else {
		ym('params', { [eventName]: eventParams });
	}
};
